// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__30tkm","isClickable":"Tag_isClickable__2vFUE"};